import * as React from "react";
import { TitleSectionFormRegistration } from "../../../FormRegistration/components/TitleSection";
import TextInputFormRegistration from "../../../FormRegistration/components/TextInput/TextInput";
import { useRegistrationFormDance } from "../../../../../store/user";
import { useNavigate, useParams } from "react-router-dom";
import classNames from "classnames";
import useWindowSize from "../../../../../hooks/useWindowSize";

interface Props {
  isLoading: boolean;
  setStep: (step: number) => void;
  onOpenConfirmation: () => void;
}

const StepDataTeam: React.FC<Props> = ({
  isLoading = false,
  setStep,
  onOpenConfirmation,
}) => {
  const navigate = useNavigate();
  const { size } = useWindowSize();
  // @ts-ignore
  const isDesktopView = (size?.width || 0) >= 768;

  const [typingError, setTypingError] = React.useState<string>("");

  const { category, city, mode } = useParams();
  const { dataTeam, errorTeam, setErrorTeam, setDataTeam } =
    useRegistrationFormDance();

  const isButtonDisabled = false;

  const handleChangeInput = (value: string, name: string) => {
    setErrorTeam({ ...errorTeam, [name]: "" });
    setDataTeam({ ...dataTeam, [name]: value });
  };

  const handleTypingValidationError = (error: string) => {
    setTypingError(error);
  };

  const handleNextStep = () => {
    return onOpenConfirmation();
  };

  const handleBackStep = () => {
    setStep(1);
  };

  return (
    <div
      className={classNames("h-auto overflow-y-auto pb-[60px]", {
        "pb-[20px]": isDesktopView,
      })}
    >
      <TitleSectionFormRegistration
        title="Masukan Data Tim Dance Competition"
        category={String(category).toUpperCase()}
        chipColor="#F48120"
        chipText="Dance"
        isDance
      />

      <div className="flex flex-col gap-y-[4px]">
        <div className="flex gap-x-2 items-center px-[22px]">
          <p className="text-[14px] font-bold text-[#00BCF1] w-[25%]">
            Peserta ke-1
          </p>
          <div className="h-[1px] w-[75%] bg-[#DDE2E8]" />
        </div>
        <TextInputFormRegistration
          label="Nama Peserta ke-1"
          name="name_team_member_1"
          isRequired={false}
          value={dataTeam?.name_team_member_1 ?? ""}
          placeholder="Masukin nama peserta"
          errorMessage={errorTeam?.name_team_member_1 ?? ""}
          type="text"
          onChangeValue={handleChangeInput}
        />
        <TextInputFormRegistration
          label="Nomor Peserta ke-1"
          name="number_team_member_1"
          value={dataTeam?.number_team_member_1 ?? ""}
          errorMessage={errorTeam?.number_team_member_1 ?? ""}
          placeholder="Masukin nomor hp peserta"
          type="number"
          onChangeValue={handleChangeInput}
          checkingValidationType="onTyping"
          validation={["phone_number"]}
          maxLength={14}
          onErrortypingValidation={handleTypingValidationError}
        />
        <div className="flex gap-x-2 items-center px-[22px]">
          <p className="text-[14px] font-bold text-[#00BCF1] w-[25%]">
            Peserta ke-2
          </p>
          <div className="h-[1px] w-[75%] bg-[#DDE2E8]" />
        </div>
        <TextInputFormRegistration
          label="Nama Peserta ke-2"
          name="name_team_member_2"
          isRequired={false}
          value={dataTeam?.name_team_member_2 ?? ""}
          placeholder="Masukin nama peserta"
          errorMessage={errorTeam?.name_team_member_2 ?? ""}
          type="text"
          onChangeValue={handleChangeInput}
        />
        <TextInputFormRegistration
          label="Nomor Peserta ke-2"
          name="number_team_member_2"
          value={dataTeam?.number_team_member_2 ?? ""}
          errorMessage={errorTeam?.number_team_member_2 ?? ""}
          placeholder="Masukin nomor hp peserta"
          type="number"
          onChangeValue={handleChangeInput}
          checkingValidationType="onTyping"
          validation={["phone_number"]}
          maxLength={14}
          onErrortypingValidation={handleTypingValidationError}
        />
        <div className="flex gap-x-2 items-center px-[22px]">
          <p className="text-[14px] font-bold text-[#00BCF1] w-[25%]">
            Peserta ke-3
          </p>
          <div className="h-[1px] w-[75%] bg-[#DDE2E8]" />
        </div>
        <TextInputFormRegistration
          label="Nama Peserta ke-3"
          name="name_team_member_3"
          isRequired={false}
          value={dataTeam?.name_team_member_3 ?? ""}
          placeholder="Masukin nama peserta"
          errorMessage={errorTeam?.name_team_member_3 ?? ""}
          type="text"
          onChangeValue={handleChangeInput}
        />
        <TextInputFormRegistration
          label="Nomor Peserta ke-3"
          name="number_team_member_3"
          value={dataTeam?.number_team_member_3 ?? ""}
          errorMessage={errorTeam?.number_team_member_3 ?? ""}
          placeholder="Masukin nomor hp peserta"
          type="number"
          onChangeValue={handleChangeInput}
          checkingValidationType="onTyping"
          validation={["phone_number"]}
          maxLength={14}
          onErrortypingValidation={handleTypingValidationError}
        />
        <div className="flex gap-x-2 items-center px-[22px]">
          <p className="text-[14px] font-bold text-[#00BCF1] w-[25%]">
            Peserta ke-4
          </p>
          <div className="h-[1px] w-[75%] bg-[#DDE2E8]" />
        </div>
        <TextInputFormRegistration
          label="Nama Peserta ke-4"
          name="name_team_member_4"
          isRequired={false}
          value={dataTeam?.name_team_member_4 ?? ""}
          placeholder="Masukin nama peserta"
          errorMessage={errorTeam?.name_team_member_4 ?? ""}
          type="text"
          onChangeValue={handleChangeInput}
        />
        <TextInputFormRegistration
          label="Nomor Peserta ke-4"
          name="number_team_member_4"
          value={dataTeam?.number_team_member_4 ?? ""}
          errorMessage={errorTeam?.number_team_member_4 ?? ""}
          placeholder="Masukin nomor hp peserta"
          type="number"
          onChangeValue={handleChangeInput}
          checkingValidationType="onTyping"
          validation={["phone_number"]}
          maxLength={14}
          onErrortypingValidation={handleTypingValidationError}
        />
        <div className="flex gap-x-2 items-center px-[22px]">
          <p className="text-[14px] font-bold text-[#00BCF1] w-[25%]">
            Peserta ke-5
          </p>
          <div className="h-[1px] w-[75%] bg-[#DDE2E8]" />
        </div>
        <TextInputFormRegistration
          label="Nama Peserta ke-5"
          name="name_team_member_5"
          isRequired={false}
          value={dataTeam?.name_team_member_5 ?? ""}
          placeholder="Masukin nama peserta"
          errorMessage={errorTeam?.name_team_member_5 ?? ""}
          type="text"
          onChangeValue={handleChangeInput}
        />
        <TextInputFormRegistration
          label="Nomor Peserta ke-5"
          name="number_team_member_5"
          value={dataTeam?.number_team_member_5 ?? ""}
          errorMessage={errorTeam?.number_team_member_5 ?? ""}
          placeholder="Masukin nomor hp peserta"
          type="number"
          onChangeValue={handleChangeInput}
          checkingValidationType="onTyping"
          validation={["phone_number"]}
          maxLength={14}
          onErrortypingValidation={handleTypingValidationError}
        />
        <div className="flex gap-x-2 items-center px-[22px]">
          <p className="text-[14px] font-bold text-[#00BCF1] w-[25%]">
            Peserta ke-6
          </p>
          <div className="h-[1px] w-[75%] bg-[#DDE2E8]" />
        </div>
        <TextInputFormRegistration
          label="Nama Peserta ke-6"
          name="name_team_member_6"
          isRequired={false}
          value={dataTeam?.name_team_member_6 ?? ""}
          placeholder="Masukin nama peserta"
          errorMessage={errorTeam?.name_team_member_6 ?? ""}
          type="text"
          onChangeValue={handleChangeInput}
        />
        <TextInputFormRegistration
          label="Nomor Peserta ke-6"
          name="number_team_member_6"
          value={dataTeam?.number_team_member_6 ?? ""}
          errorMessage={errorTeam?.number_team_member_6 ?? ""}
          placeholder="Masukin nomor hp peserta"
          type="number"
          onChangeValue={handleChangeInput}
          checkingValidationType="onTyping"
          validation={["phone_number"]}
          maxLength={14}
          onErrortypingValidation={handleTypingValidationError}
        />
        <div className="flex gap-x-2 items-center px-[22px]">
          <p className="text-[14px] font-bold text-[#00BCF1] w-[25%]">
            Peserta ke-7
          </p>
          <div className="h-[1px] w-[75%] bg-[#DDE2E8]" />
        </div>
        <TextInputFormRegistration
          label="Nama Peserta ke-7"
          name="name_team_member_7"
          isRequired={false}
          value={dataTeam?.name_team_member_7 ?? ""}
          placeholder="Masukin nama peserta"
          errorMessage={errorTeam?.name_team_member_7 ?? ""}
          type="text"
          onChangeValue={handleChangeInput}
        />
        <TextInputFormRegistration
          label="Nomor Peserta ke-7"
          name="number_team_member_7"
          value={dataTeam?.number_team_member_7 ?? ""}
          errorMessage={errorTeam?.number_team_member_7 ?? ""}
          placeholder="Masukin nomor hp peserta"
          type="number"
          onChangeValue={handleChangeInput}
          checkingValidationType="onTyping"
          validation={["phone_number"]}
          maxLength={14}
          onErrortypingValidation={handleTypingValidationError}
        />
        <div className="flex gap-x-2 items-center px-[22px]">
          <p className="text-[14px] font-bold text-[#00BCF1] w-[25%]">
            Peserta ke-8
          </p>
          <div className="h-[1px] w-[75%] bg-[#DDE2E8]" />
        </div>
        <TextInputFormRegistration
          label="Nama Peserta ke-8"
          name="name_team_member_8"
          isRequired={false}
          value={dataTeam?.name_team_member_8 ?? ""}
          placeholder="Masukin nama peserta"
          errorMessage={errorTeam?.name_team_member_8 ?? ""}
          type="text"
          onChangeValue={handleChangeInput}
        />
        <TextInputFormRegistration
          label="Nomor Peserta ke-8"
          name="number_team_member_8"
          value={dataTeam?.number_team_member_8 ?? ""}
          errorMessage={errorTeam?.number_team_member_8 ?? ""}
          placeholder="Masukin nomor hp peserta"
          type="number"
          onChangeValue={handleChangeInput}
          checkingValidationType="onTyping"
          validation={["phone_number"]}
          maxLength={14}
          onErrortypingValidation={handleTypingValidationError}
        />
        <div className="flex gap-x-2 items-center px-[22px]">
          <p className="text-[14px] font-bold text-[#00BCF1] w-[25%]">
            Peserta ke-9
          </p>
          <div className="h-[1px] w-[75%] bg-[#DDE2E8]" />
        </div>
        <TextInputFormRegistration
          label="Nama Peserta ke-9"
          name="name_team_member_9"
          isRequired={false}
          value={dataTeam?.name_team_member_9 ?? ""}
          placeholder="Masukin nama peserta"
          errorMessage={errorTeam?.name_team_member_9 ?? ""}
          type="text"
          onChangeValue={handleChangeInput}
        />
        <TextInputFormRegistration
          label="Nomor Peserta ke-9"
          name="number_team_member_9"
          value={dataTeam?.number_team_member_9 ?? ""}
          errorMessage={errorTeam?.number_team_member_9 ?? ""}
          placeholder="Masukin nomor hp peserta"
          type="number"
          onChangeValue={handleChangeInput}
          checkingValidationType="onTyping"
          validation={["phone_number"]}
          maxLength={14}
          onErrortypingValidation={handleTypingValidationError}
        />
        <div className="flex gap-x-2 items-center px-[22px]">
          <p className="text-[14px] font-bold text-[#00BCF1] w-[25%]">
            Peserta ke-10
          </p>
          <div className="h-[1px] w-[75%] bg-[#DDE2E8]" />
        </div>
        <TextInputFormRegistration
          label="Nama Peserta ke-10"
          name="name_team_member_10"
          isRequired={false}
          value={dataTeam?.name_team_member_10 ?? ""}
          placeholder="Masukin nama peserta"
          errorMessage={errorTeam?.name_team_member_10 ?? ""}
          type="text"
          onChangeValue={handleChangeInput}
        />
        <TextInputFormRegistration
          label="Nomor Peserta ke-10"
          name="number_team_member_10"
          value={dataTeam?.number_team_member_10 ?? ""}
          errorMessage={errorTeam?.number_team_member_10 ?? ""}
          placeholder="Masukin nomor hp peserta"
          type="number"
          onChangeValue={handleChangeInput}
          checkingValidationType="onTyping"
          validation={["phone_number"]}
          maxLength={14}
          onErrortypingValidation={handleTypingValidationError}
        />
      </div>

      <div className="w-full max-w-[600px] flex px-[24px] py-[16px] gap-x-[16px]">
        <button
          disabled={isLoading}
          onClick={handleBackStep}
          className="rounded-[32px] border-[1px] border-[#1F2D3D] py-[12px] px-[16px] text-[16px] text-[#1F2D3D] leading-none font-semibold w-[50%]"
        >
          Kembali
        </button>
        <button
          disabled={isLoading || typingError?.length > 0}
          onClick={handleNextStep}
          className={classNames(
            "rounded-[32px] bg-[#00BCF1] py-[12px] px-[16px] text-[16px] leading-none font-semibold w-[50%] text-white",
            {
              "bg-[#00BCF1]": !isButtonDisabled,
              "bg-slate-300": isButtonDisabled,
            }
          )}
        >
          Lanjut
        </button>
      </div>
    </div>
  );
};

export default StepDataTeam;
